import React from 'react'
import {
  Button,
  Input,
  FormControl,
  FormLabel,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useToast,
} from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { DragAndDrop } from '../DragAndDrop'
import { uploadImagePost } from '../../pages/ADM/Blog/functions/uploadImagePost'

export function ImageDialog({ isOpen, onClose, onInsert, imageSize }) {
  const { handleSubmit, control, register, watch } = useForm()

  const toast = useToast()

  const handleInsert = async (data) => {
    if (!data.contentImagePost) {
      return toast({
        title: 'Por favor, escolha uma imagem',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }

    if (data.contentImagePost.size > imageSize) {
      return toast({
        title: `Imagem maior que ${imageSize / 1000}kb, por favor, escolha uma imagem menor`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }

    const { url } = await uploadImagePost(data.contentImagePost)

    if (!url) {
      return
    }

    console.log('url', url, data.altText)

    onInsert(url, data.altText)

    onClose()

    return
  }

  console.log(watch('contentImagePost'))

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent as="form" onSubmit={handleSubmit(handleInsert)} borderRadius="md" p={4} w="100%">
        <ModalHeader>Inserir Imagem</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl id="imageUrl">
            <DragAndDrop name="contentImagePost" control={control} />
          </FormControl>
          <FormControl id="altText" mt={4}>
            <FormLabel>Texto Alternativo</FormLabel>
            <Input type="text" {...register('altText')} placeholder="Digite o texto alternativo" />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" colorScheme="blue" mr={3}>
            Inserir
          </Button>
          <Button variant="outline" onClick={onClose}>
            Cancelar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
